import Bootstrap4DisclosureMenu from "./src/bootstrap4DisclosureMenu.js";
import Bootstrap4Menubar from "./src/bootstrap4Menubar.js";
import Bootstrap4Treeview from "./src/bootstrap4Treeview.js";

export default {
  Bootstrap4DisclosureMenu,
  Bootstrap4Menubar,
  Bootstrap4Treeview,
};
